import { useTenants } from '@/services/tenants/useTenants';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { SHOW_HELP_PARAM, HELP_SECTION_PARAM } from './helpParameters';
import { HelpSection } from './HelpContent';

const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'underline',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

interface HelpLinkProperties {
  to: string;
  helpSection?: HelpSection;
  onClick?: (event: React.MouseEvent) => void;
  children: React.ReactNode;
}

export const HelpLink = ({ to, helpSection, onClick, children }: HelpLinkProperties) => {
  const { getPath } = useTenants();

  const stopPropagation = (event: React.MouseEvent) => {
    event.stopPropagation();
    onClick?.(event);
  };

  const buildUrl = () => {
    const basePath = getPath(to);
    const parameters = new URLSearchParams();
    parameters.set(SHOW_HELP_PARAM, '1');
    if (helpSection) {
      parameters.set(HELP_SECTION_PARAM, helpSection);
    }
    return `${basePath}?${parameters.toString()}`;
  };

  return (
    <StyledLink to={buildUrl()} onClick={stopPropagation}>
      {children}
    </StyledLink>
  );
};
